
import { useQuery } from '@tanstack/react-query';
import { getProductsWithCategories } from '@/services/productService';

export interface ProductWithDetails {
  id: string;
  name: string;
  description: string | null;
  unit_of_measure: string;
  categories?: {
    name: string;
  } | null;
}

export const useGetProductsWithDetails = () => {
  return useQuery({
    queryKey: ['products-with-details'],
    queryFn: getProductsWithCategories
  });
};
